import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getEmployee = (token: string, backend: string, id: number) => {
    return fetch(`${getApiUrl(backend)}employees/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getEmployee